// Public report pages live on the customer-facing site, not the Wave app.
const REPORT_VIEW_ORIGIN = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3001'
  : 'https://www.proasysinc.com';

export const reportViewUrl = (hashId) => (
  hashId ? `${REPORT_VIEW_ORIGIN}/reports/view?id=${hashId}` : undefined
);
